import * as Actions from './actions/actions'
import * as ActionTypes from './actions/types'
import requestHandler from './api/api'
import locales from './locales/locales'
import reducer from './reducer/reducer'
import router from './routes/routes'

export const IssuesModule = {
    name: 'issues',
    routes: router,
    actions: Actions,
    types: ActionTypes,
    reducer: reducer,
    api: requestHandler,
    locales: locales,
    modules: []
}